export const textModalPlayToEarn = [
  {
    textHead: "Requirements:",
    textBody: ["- You will need to stake 300 BEET."],
  },
  {
    textHead: "Rules:",
    textBody: [
      "- You can play up 3 game sessions.",
      "- All rewards earned will sent to Stake vault and vested 90 days period.",
      "- If you want to play more after 3 game sessions, you will need to stake another 300 BEET.",
    ],
  },
  {
    textHead: "Rewards Calculation:",
    textBody: ["Rewards = Score * 10%"],
  },
];
